import httpInstance from '../httpInstance';

const getAllRubros = async () => {
  let res;
  const endpoint = '/frontlabels/v1/business/rubro';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getAllRubros;
